export const createGetMyOrgDetailsRequest = () => {
  return {
    url: "/orgs/me",
    method: "GET",
  };
};

export const createGetMyOrgInvitationRequest = () => {
  return {
    url: "/orgs/invitations/me",
    method: "GET",
  };
}

export const createAcceptOrgInvitationRequest = (invitationId) => {
  return {
    url: "/orgs/invitations/accept",
    method: "POST",
    data: { invitation_id: invitationId },
  };
}

export const createGetOrgMembersRequest = () => {
  return {
    url: "/orgs/members",
    method: "GET",
  };
}

export const createGetPendingInvitationsRequest = () => {
  return {
    url: "/orgs/invitations/pending",
    method: "GET",
  };
}

export const createInviteMembersRequest = (emails, redirectUrl, role = "ORG_MEMBER") => {
  return {
    url: "/orgs/invitations/invite_members/",
    method: "POST",
    data: {
      emails: emails,
      redirect_url: redirectUrl,
      role: role
    }
  };
}

export const createUpdateOrgMemberRoleRequest = (userId, role) => {
  return {
    url: `/orgs/members/${userId}/role`,
    method: "PUT",
    data: { role },
  };
};

export const createRemoveOrgMemberRequest = (userId) => {
  return {
    url: `/orgs/members/${userId}`,
    method: "DELETE",
  };
};

export const createDeleteInvitationRequest = (invitationId) => {
  return {
    url: `/orgs/invitations/${invitationId}`,
    method: "DELETE",
  };
}

export const createGetOrgDashboardCardsRequest = () => {
  return {
    url: "/orgs/dashboard/cards",
    method: "GET",
  };
}

export const createAdvocacyChallengeRequest = (challengeData) => {
  return {
    url: "/orgs/advocacy_challenges/",
    method: "POST",
    data: challengeData,
  };
}

export const createGetAdvocacyChallengesRequest = () => {
  return {
    url: "/orgs/advocacy_challenges/",
    method: "GET",
  };
}

export const createGetAdvocacyChallengeRequest = (challengeId) => {
  return {
    url: `/orgs/advocacy_challenges/${challengeId}/`,
    method: "GET",
  };
}

export const createUpdateAdvocacyChallengeRequest = (challengeId, challengeData) => {
  return {
    url: `/orgs/advocacy_challenges/${challengeId}/`,
    method: "PUT",
    data: challengeData,
  };
}

export const createDeleteAdvocacyChallengeRequest = (challengeId) => {
  return {
    url: `/orgs/advocacy_challenges/${challengeId}/`,
    method: "DELETE",
  };
}

export const createCancelAdvocacyChallengeRequest = (challengeId) => {
  return {
    url: `/orgs/advocacy_challenges/${challengeId}/cancel`,
    method: "POST",
  };
}

export const createStartAdvocacyChallengeRequest = (challengeId) => {
  return {
    url: `/orgs/advocacy_challenges/${challengeId}/start`,
    method: "POST",
  };
}

export const createInviteAdvocacyChallengeParticipantsRequest = (challengeId, userIds) => {
  return {
    url: `/orgs/advocacy_challenges/${challengeId}/participants`,
    method: "POST",
    data: {
      user_ids: userIds
    }
  };
}

export const createGetAdvocacyChallengeParticipantsRequest = (challengeId) => {
  return {
    url: `/orgs/advocacy_challenges/${challengeId}/participants`,
    method: "GET",
  };
}

export const createDeleteAdvocacyChallengeParticipantRequest = (challengeId, participantId) => {
  return {
    url: `/orgs/advocacy_challenges/${challengeId}/participants/${participantId}`,
    method: "DELETE",
  };
}

export const createGetAdvocacyChallengeLeaderboardRequest = (challengeId) => {
  return {
    url: `/orgs/advocacy_challenges/${challengeId}/leaderboard`,
    method: "GET",
  };
}

export const createGetOrgWorkspacesRequest = () => {
  return {
    url: "/orgs/workspaces",
    method: "GET",
  };
};

export const createOrgWorkspaceForMeRequest = (workspaceData) => {
  return {
    url: "/orgs/workspaces/me",
    method: "POST",
    data: workspaceData,
  };
};

// Org Calendar API requests
export const createGetOrgCalendarRequest = (offset, viewType, timezone, workspaceId) => {
  const params = {
    view_type: viewType,
    offset: offset,
  };
  if (timezone) {
    params.timezone = timezone;
  }
  if (workspaceId) {
    params.workspace_id = workspaceId;
  }
  return {
    url: "/orgs/calendar",
    method: "GET",
    params,
  };
};

export const createGetOrgCalendarPostsRequest = (status, workspaceId, page = 1, perPage = 100) => {
  const params = { page, per_page: perPage };
  if (status) {
    params.status = status;
  }
  if (workspaceId) {
    params.workspace_id = workspaceId;
  }
  return {
    url: "/orgs/calendar/posts",
    method: "GET",
    params,
  };
};

export const createGetOrgCalendarWorkspacesRequest = () => {
  return {
    url: "/orgs/calendar/workspaces",
    method: "GET",
  };
};

export const createGetOrgNextFreeTimeSlotRequest = (workspaceId, timezone) => {
  const params = {};
  if (workspaceId) {
    params.workspace_id = workspaceId;
  }
  if (timezone) {
    params.timezone = timezone;
  }
  return {
    url: "/orgs/calendar/next_free_time_slot",
    method: "GET",
    params,
  };
};

export const createOrgTimeSlotInstanceRequest = (data) => {
  return {
    url: "/orgs/time_slot_instances",
    method: "POST",
    data,
  };
};

export const createDeleteOrgTimeSlotInstanceRequest = (id) => {
  return {
    url: `/orgs/time_slot_instances/${id}`,
    method: "DELETE",
  };
};

export const createGetAdvocacyChallengeParticipantDetailsRequest = (challengeId, participantId, userIds = []) => {
  return {
    url: `/orgs/advocacy_challenges/${challengeId}/participants/${participantId}`,
    method: "GET",
    data: {
      user_ids: userIds
    }
  };
}

// Admin Weekly Report API requests
export const createGetAdminWeeklyReportsListRequest = (limit = 12) => {
  return {
    url: "/orgs/admin_weekly_reports",
    method: "GET",
    params: { limit },
  };
};

export const createGetCurrentAdminWeeklyReportRequest = () => {
  return {
    url: "/orgs/admin_weekly_reports/current",
    method: "GET",
  };
};

export const createGetAdminWeeklyReportRequest = (reportId) => {
  return {
    url: `/orgs/admin_weekly_reports/${reportId}`,
    method: "GET",
  };
};

// Org Contents API requests
export const createGetOrgContentsRequest = (params = {}) => {
  return {
    url: "/orgs/contents",
    method: "GET",
    params,
  };
};

export const createGetOrgContentRequest = (contentId) => {
  return {
    url: `/orgs/contents/${contentId}`,
    method: "GET",
  };
};

export const createOrgContentRequest = (data) => {
  return {
    url: "/orgs/contents",
    method: "POST",
    data,
  };
};

export const createUpdateOrgContentRequest = (contentId, data) => {
  return {
    url: `/orgs/contents/${contentId}`,
    method: "PUT",
    data,
  };
};

export const createDeleteOrgContentRequest = (contentId) => {
  return {
    url: `/orgs/contents/${contentId}`,
    method: "DELETE",
  };
};

export const createSendOrgContentToWorkspacesRequest = (contentId, workspaceIds) => {
  return {
    url: `/orgs/contents/${contentId}/send`,
    method: "POST",
    data: { workspace_ids: workspaceIds },
  };
};

export const createOrgBulkUploadPostsRequest = (posts, notifyMembers = false) => {
  return {
    url: "/orgs/posts/bulk",
    method: "POST",
    data: { posts, notify_members: notifyMembers },
  };
};

// Org Post with Activity
export const createGetOrgPostWithActivityRequest = (workspaceId, postId) => {
  return {
    url: `/orgs/posts/${postId}`,
    method: "GET",
    params: { workspace_id: workspaceId },
    disableLoading: true,
  };
};

// Org Post CRUD
export const createGetOrgPostRequest = (postId, workspaceId, disableLoading = false) => {
  return {
    url: `/orgs/posts/${postId}`,
    method: "GET",
    params: { workspace_id: workspaceId },
    disableLoading,
  };
};

export const createOrgPostRequest = (data) => {
  return {
    url: "/orgs/posts",
    method: "POST",
    data,
  };
};

export const createUpdateOrgPostRequest = (postId, data) => {
  return {
    url: `/orgs/posts/${postId}`,
    method: "PUT",
    data,
  };
};

export const createUpdateOrgPostStatusRequest = (postId, data) => {
  return {
    url: `/orgs/posts/${postId}/status`,
    method: "PUT",
    data,
  };
};

export const createDeleteOrgPostRequest = (postId, workspaceId) => {
  return {
    url: `/orgs/posts/${postId}`,
    method: "DELETE",
    params: { workspace_id: workspaceId },
  };
};

export const createOrgConvertFailedPostToDraftRequest = (postId, workspaceId) => {
  return {
    url: `/orgs/posts/${postId}/convert_failed_post_to_draft`,
    method: "POST",
    data: { workspace_id: workspaceId },
  };
};

// Org Post Public Link
export const createOrgEnablePublicPostLinkRequest = (postId, workspaceId) => {
  return {
    url: `/orgs/posts/${postId}/public_link`,
    method: "POST",
    data: {
      workspace_id: workspaceId,
      enable_public_feedback_comments: true,
    },
  };
};

export const createOrgDisablePublicPostLinkRequest = (postId, workspaceId) => {
  return {
    url: `/orgs/posts/${postId}/public_link`,
    method: "DELETE",
    data: {
      workspace_id: workspaceId,
    },
  };
};

export const createOrgEnablePublicPostFeedbackRequest = (postId, workspaceId, enable = true) => {
  return {
    url: `/orgs/posts/${postId}/public_link`,
    method: "POST",
    data: {
      workspace_id: workspaceId,
      enable_public_feedback_comments: enable,
    },
  };
};

// Org Kanban
export const createGetOrgKanbanRequest = (workspaceId, page = 1, perPage = 20) => {
  const params = { page, per_page: perPage };
  if (workspaceId) {
    params.workspace_id = workspaceId;
  }
  return {
    url: "/orgs/kanban",
    method: "GET",
    params,
  };
};

export const createGetOrgKanbanByStatusRequest = (status, workspaceId, page = 1, perPage = 20) => {
  const params = { page, per_page: perPage };
  if (workspaceId) {
    params.workspace_id = workspaceId;
  }
  return {
    url: `/orgs/kanban/${status}`,
    method: "GET",
    params,
  };
};

// Org Workspace LinkedIn Integrations & Company Pages
export const createGetOrgWorkspaceLinkedInIntegrationsRequest = (workspaceId, disableLoading = false) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/linkedin_integrations`,
    method: "GET",
    disableLoading,
  };
};

export const createGetOrgWorkspaceCompanyPagesRequest = (workspaceId, disableLoading = false) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/company_pages`,
    method: "GET",
    disableLoading,
  };
};

export const createGetOrgWorkspaceCompanyPageInfoRequest = (workspaceId, companyUrl, postIdentity = {}, disableLoading = false) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/company_pages/info`,
    method: "GET",
    params: {
      company_url: companyUrl,
      ...postIdentity,
    },
    disableLoading,
  };
};

export const createOrgUnfurlUrlRequest = (url) => {
  return {
    url: "/orgs/posts/unfurl",
    method: "POST",
    data: { url },
    disableLoading: true,
  };
};

// Org Workspace Settings
export const createGetOrgWorkspaceSettingsRequest = (workspaceId) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/settings`,
    method: "GET",
  };
};

export const createUpdateOrgWorkspaceSettingsRequest = (workspaceId, settings) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/settings`,
    method: "PUT",
    data: settings,
  };
};

// Org Publish Post
export const createOrgPublishPostRequest = (post, workspaceId, async = true) => {
  return {
    url: `/orgs/posts/${post.id}/publish`,
    method: "POST",
    data: {
      async,
      workspace_id: workspaceId,
    },
  };
};

// Org Workspace Members
export const createGetOrgWorkspaceMembersRequest = (workspaceId) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/members`,
    method: "GET",
  };
};

// Org Workspace Reviewers
export const createGetOrgWorkspaceReviewersRequest = (workspaceId) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/reviewers`,
    method: "GET",
  };
};

// Org Post Approval/Review
export const createOrgSendPostForApprovalRequest = ({ postId, approver_user_id, review_message, workspaceId }) => {
  return {
    url: `/orgs/posts/${postId}/approval/request`,
    method: "POST",
    params: { workspace_id: workspaceId },
    data: {
      approver_user_id,
      review_message,
    },
  };
};

export const createOrgCancelPostSentForApprovalRequest = ({ postId, post_review_id, workspaceId }) => {
  return {
    url: `/orgs/posts/${postId}/approval/request/${post_review_id}/cancel`,
    method: "POST",
    params: { workspace_id: workspaceId },
  };
};

export const createOrgBulkSendForApprovalRequest = (posts, approverUserId) => ({
  url: "/orgs/posts/bulk_approval/request",
  method: "POST",
  data: { posts, approver_user_id: approverUserId },
});

export const createOrgBulkDeletePostsRequest = (posts) => ({
  url: "/orgs/posts/bulk_delete",
  method: "POST",
  data: { posts },
});

export const createOrgBulkCopyPostsRequest = (sourcePostId, sourceWorkspaceId, targetWorkspaceIds, notifyMembers = true) => ({
  url: "/orgs/posts/bulk_copy",
  method: "POST",
  data: {
    source_post_id: sourcePostId,
    source_workspace_id: sourceWorkspaceId,
    target_workspace_ids: targetWorkspaceIds,
    notify_members: notifyMembers,
  },
});

// Org Time Slots (per-workspace)
export const createGetOrgTimeSlotsRequest = () => {
  return {
    url: "/orgs/time_slots",
    method: "GET",
  };
};

export const createSaveOrgWorkspaceTimeSlotRequest = (workspaceId, day_of_week, hour, minute) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/time_slots`,
    method: "POST",
    data: { day_of_week, hour, minute },
  };
};

export const createDeleteOrgWorkspaceTimeSlotRequest = (workspaceId, id) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/time_slots/${id}`,
    method: "DELETE",
  };
};

export const createDeleteOrgWorkspaceTimeSlotsRequest = (workspaceId, ids) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/time_slots`,
    method: "DELETE",
    data: { ids },
  };
};

// Org Workspace Tags
export const createGetOrgWorkspaceTagsRequest = (workspaceId) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/tags`,
    method: "GET",
  };
};

export const createOrgWorkspaceTagRequest = (workspaceId, name) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/tags`,
    method: "POST",
    data: { name },
  };
};

// Org Workspace Tag Groups (SUP-564) — admin-defined tag dimensions + values.
// Distinct from the content-tag `/workspaces/:id/tags` endpoints above.
export const createGetWorkspaceTagGroupsRequest = () => {
  return {
    url: "/orgs/workspace_tag_groups",
    method: "GET",
  };
};

export const createCreateWorkspaceTagGroupRequest = (name) => {
  return {
    url: "/orgs/workspace_tag_groups",
    method: "POST",
    data: { name },
  };
};

export const createUpdateWorkspaceTagGroupRequest = (groupId, data) => {
  return {
    url: `/orgs/workspace_tag_groups/${groupId}`,
    method: "PUT",
    data,
  };
};

export const createDeleteWorkspaceTagGroupRequest = (groupId) => {
  return {
    url: `/orgs/workspace_tag_groups/${groupId}`,
    method: "DELETE",
  };
};

export const createCreateWorkspaceTagOptionRequest = (groupId, name) => {
  return {
    url: `/orgs/workspace_tag_groups/${groupId}/options`,
    method: "POST",
    data: { name },
  };
};

export const createUpdateWorkspaceTagOptionRequest = (optionId, data) => {
  return {
    url: `/orgs/workspace_tag_options/${optionId}`,
    method: "PUT",
    data,
  };
};

export const createDeleteWorkspaceTagOptionRequest = (optionId) => {
  return {
    url: `/orgs/workspace_tag_options/${optionId}`,
    method: "DELETE",
  };
};

export const createUpdateWorkspaceTagAssignmentsRequest = (workspaceId, assignments) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/tag_assignments`,
    method: "PUT",
    data: { assignments },
  };
};

// Org AI
export const createOrgGeneratePostScoreRequest = (workspaceId, post) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/ai/generate_post_score`,
    method: "POST",
    data: { post },
    disableLoading: true,
  };
};

// --- Org Draft Adaptation ---

export const createAdaptOrgContentRequest = (contentId, data) => {
  return {
    url: `/orgs/contents/${contentId}/adapt`,
    method: "POST",
    data,
  };
};

export const createGetAdaptStatusRequest = (contentId) => {
  return {
    url: `/orgs/contents/${contentId}/adapt/status`,
    method: "GET",
    disableLoading: true,
  };
};

export const createSelectAdaptVersionRequest = (contentId, transformationId, data) => {
  return {
    url: `/orgs/contents/${contentId}/adapt/${transformationId}/select`,
    method: "PUT",
    data,
  };
};

export const createEditAdaptVersionRequest = (contentId, transformationId, versionId, data) => {
  return {
    url: `/orgs/contents/${contentId}/adapt/${transformationId}/versions/${versionId}`,
    method: "PUT",
    data,
  };
};

export const createRegenerateAdaptVersionRequest = (contentId, transformationId, versionId, data) => {
  return {
    url: `/orgs/contents/${contentId}/adapt/${transformationId}/versions/${versionId}/regenerate`,
    method: "POST",
    data,
  };
};

export const createRevertAdaptTransformationRequest = (contentId, transformationId) => {
  return {
    url: `/orgs/contents/${contentId}/adapt/${transformationId}/revert`,
    method: "POST",
  };
};

export const createSendAdaptedContentRequest = (contentId, data) => {
  return {
    url: `/orgs/contents/${contentId}/adapt/send`,
    method: "POST",
    data,
  };
};

// --- Org Workspace Content DNA ---

export const createGetOrgWorkspaceContentDnaRequest = (workspaceId) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/content_dna`,
    method: "GET",
  };
};

export const createRegenerateOrgWorkspaceContentDnaRequest = (workspaceId, data) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/content_dna/regenerate`,
    method: "POST",
    data,
  };
};

export const createImportOrgWorkspaceContentDnaRequest = (workspaceId, content) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/content_dna/import`,
    method: "POST",
    data: { content },
  };
};

export const createUpdateOrgWorkspaceContentDnaRequest = (workspaceId, data) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/content_dna`,
    method: "PUT",
    data,
  };
};

export const createOrgWorkspaceConfirmContentDnaRequest = (workspaceId) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/content_dna/confirm`,
    method: "POST",
  };
};

// Org Content DNA Template (SUP-296) — brand defaults seeded into new workspaces

export const createGetOrgContentDnaTemplateRequest = () => {
  return {
    url: "/orgs/content_dna_template",
    method: "GET",
  };
};

export const createUpdateOrgContentDnaTemplateRequest = (data) => {
  return {
    url: "/orgs/content_dna_template",
    method: "PUT",
    data,
  };
};

// Org Analytics Dashboard
export const createGetOrgAnalyticsDashboardRequest = (range, startDate, endDate, granularity, options = {}) => {
  const params = { range };
  if (range === "custom" && startDate && endDate) {
    params.start_date = startDate;
    params.end_date = endDate;
  }
  if (granularity) {
    params.granularity = granularity;
  }
  // SUP-564 tag filter (AND-composed across dimensions) + group-by. The server
  // accepts a comma-separated `tag_option_ids`; `group_by` takes a group id.
  const { tagOptionIds, groupBy, workspaceIds } = options;
  if (tagOptionIds && tagOptionIds.length > 0) {
    params.tag_option_ids = tagOptionIds.join(",");
  }
  if (groupBy) {
    params.group_by = groupBy;
  }
  if (workspaceIds && workspaceIds.length > 0) {
    params.workspace_ids = workspaceIds.join(",");
  }
  return {
    url: "/orgs/analytics/dashboard",
    method: "GET",
    params,
  };
};

// Org-wide posts table: every member's posts in the range, server-sorted and
// paged. Same range vocabulary and tag filter as the dashboard.
export const createGetOrgAnalyticsPostsRequest = ({
  range,
  startDate,
  endDate,
  tagOptionIds,
  workspaceIds,
  sort,
  limit,
  offset,
  // Drill-down from the template ranking: only the posts distributed from this template.
  orgContentId,
} = {}) => {
  const data = { range };
  if (range === "custom" && startDate && endDate) {
    data.start_date = startDate;
    data.end_date = endDate;
  }
  if (tagOptionIds && tagOptionIds.length > 0) data.tag_option_ids = tagOptionIds;
  if (workspaceIds && workspaceIds.length > 0) data.workspace_ids = workspaceIds;
  if (sort) data.sort = sort;
  if (limit != null) data.limit = limit;
  if (offset != null) data.offset = offset;
  if (orgContentId) data.org_content_id = orgContentId;
  return {
    url: "/orgs/analytics/posts",
    method: "POST",
    data,
    disableLoading: true,
  };
};

// Template performance: each Content Library template with the performance of
// the member posts distributed from it, summed over the range. Same range,
// member and tag filters as the posts table, plus a workspace language filter.
export const createGetOrgAnalyticsTemplatesRequest = ({
  range,
  startDate,
  endDate,
  tagOptionIds,
  workspaceIds,
  languages,
  sort,
  limit,
  offset,
} = {}) => {
  const data = { range };
  if (range === "custom" && startDate && endDate) {
    data.start_date = startDate;
    data.end_date = endDate;
  }
  if (tagOptionIds && tagOptionIds.length > 0) data.tag_option_ids = tagOptionIds;
  if (workspaceIds && workspaceIds.length > 0) data.workspace_ids = workspaceIds;
  if (languages && languages.length > 0) data.languages = languages;
  if (sort) data.sort = sort;
  if (limit != null) data.limit = limit;
  if (offset != null) data.offset = offset;
  return {
    url: "/orgs/analytics/templates",
    method: "POST",
    data,
    disableLoading: true,
  };
};

// Org Settings
export const createGetOrgSettingsRequest = () => {
  return {
    url: "/orgs/settings",
    method: "GET",
  };
};

export const createUpdateOrgSettingsRequest = (settings) => {
  return {
    url: "/orgs/settings",
    method: "PUT",
    data: settings,
  };
};

// Org Infographic Generations
export const createOrgInfographicGenerationRequest = (workspaceId, params) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/infographic_generations`,
    method: "POST",
    data: {
      message: params.message,
      current_image: params.currentImage || undefined,
      uploaded_image: params.uploadedImage || undefined,
      aspect_ratio: params.aspectRatio || "1:1",
    },
    disableLoading: true,
  };
};

export const getOrgInfographicGenerationRequest = (workspaceId, id) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/infographic_generations/${id}`,
    method: "GET",
    disableLoading: true,
  };
};

// Org Brand Kits
export const createGetOrgBrandKitsRequest = (workspaceId) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/brand_kits`,
    method: "GET",
  };
};

// Bulk: fetch brand kits across many workspaces in a single request.
// Response shape: { brand_kits_by_workspace: { <ws-id>: [kit, …], … } }
// When workspaceIds is omitted/empty the BE returns every workspace in the org.
export const createGetOrgBrandKitsBulkRequest = ({ workspaceIds } = {}) => {
  const params = {};
  if (workspaceIds && workspaceIds.length) {
    params.workspace_ids = workspaceIds.join(",");
  }
  return {
    url: "/orgs/brand_kits",
    method: "GET",
    params,
  };
};

export const createSaveOrgBrandKitRequest = (workspaceId, data) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/brand_kits`,
    method: "POST",
    data,
  };
};

// Org Custom Fonts
export const createGetOrgCustomFontsRequest = (workspaceId) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/custom_fonts`,
    method: "GET",
  };
};

// Bulk: fetch custom fonts across many workspaces in a single request.
// Response shape: { custom_fonts_by_workspace: { <ws-id>: [font, …], … } }
export const createGetOrgCustomFontsBulkRequest = ({ workspaceIds } = {}) => {
  const params = {};
  if (workspaceIds && workspaceIds.length) {
    params.workspace_ids = workspaceIds.join(",");
  }
  return {
    url: "/orgs/custom_fonts",
    method: "GET",
    params,
  };
};

export const createAddOrgCustomFontRequest = (workspaceId, data) => {
  return {
    url: `/orgs/workspaces/${workspaceId}/custom_fonts`,
    method: "POST",
    data,
  };
};

// Org Content Generation Tasks

export const createOrgContentGenerationTasksRequest = (data) => {
  return {
    url: '/orgs/content_generation_tasks',
    method: 'POST',
    data,
  };
};

export const createGetOrgContentGenerationTaskRequest = (taskId) => {
  return {
    url: `/orgs/content_generation_tasks/${taskId}`,
    method: 'GET',
    disableLoading: true,
  };
};

export const createGetOrgContentGenerationTasksRequest = () => {
  return {
    url: '/orgs/content_generation_tasks',
    method: 'GET',
    disableLoading: true,
  };
};

// Org Auto Plug Comments
export {
  createOrgAddBulkAutoPlugCommentRequest,
  createOrgUpdateBulkAutoPlugCommentRequest,
  createOrgDeleteBulkAutoPlugCommentRequest,
  createGetOrgCustomAutoPlugCommentsRequest,
  createSaveOrgCustomAutoPlugCommentRequest,
  createUpdateOrgCustomAutoPlugCommentRequest,
  createDeleteOrgCustomAutoPlugCommentRequest,
} from "./auto-plug-comments.js";

export const createRegenerateAllOrgContentDnaRequest = () => ({
  url: "/orgs/workspaces/content_dna/regenerate",
  method: "POST",
  data: {},
  disableLoading: true,
});

export const createGetAllOrgContentDnaStatusRequest = () => ({
  url: "/orgs/workspaces/content_dna/status",
  method: "GET",
  disableLoading: true,
});
